import { useMemo } from 'react';

import type { Dataset } from '~/api/experiments';
import {
  normalizeDatasetExperiments,
  type CollectTestCaseListItem
} from '~/scenes/Monitor/scenes/AgentLogs/utils/normalizeDatasetExperiments';

type UseAgentDatasetExperimentsParams = {
  datasets: Dataset[] | undefined;
  selectedDatasetId: string | null;
  isDatasetsLoading: boolean;
};

export function useAgentDatasetExperiments({
  datasets,
  selectedDatasetId,
  isDatasetsLoading
}: UseAgentDatasetExperimentsParams) {
  const selectedDataset = useMemo(() => {
    if (!selectedDatasetId || !datasets) {
      return null;
    }

    return datasets.find(dataset => dataset.id === selectedDatasetId) ?? null;
  }, [datasets, selectedDatasetId]);

  const testCases: CollectTestCaseListItem[] = useMemo(
    () => normalizeDatasetExperiments(selectedDataset?.experiments),
    [selectedDataset]
  );

  const isLoading = Boolean(selectedDatasetId) && isDatasetsLoading;

  return {
    selectedDataset,
    testCases,
    isLoading
  };
}
